import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-test-scenario",
  "use": "foquz-icon-question-test-scenario-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-test-scenario\"><path d=\"M1 7V3.857A2.857 2.857 0 013.857 1h14.286A2.857 2.857 0 0121 3.857V7M1 7v11.143A2.857 2.857 0 003.857 21h8.572M1 7h20m0 5.429V7m-4.879 9.121L20 20m-3-6a3 3 0 11-6 0 3 3 0 016 0z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol